import clsx from "clsx"
import {forwardRef} from "react"
import "./TextArea.css"

interface TextAreaProps extends Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, "placeholder"> {
    placeholder: string | undefined | null
    invalid?: boolean
}

const TextArea: React.FC<TextAreaProps> = forwardRef<HTMLTextAreaElement, TextAreaProps>((props, ref) => {
    const {className, children, placeholder, invalid, ...otherProps} = props
    return (
        <textarea
            ref={ref}
            className={clsx("textarea-7t3r", invalid ? "invalid-7t3r" : "", className)}
            placeholder={placeholder ? placeholder : ""}
            {...otherProps}
        />
    )
})

export default TextArea
